@if (isLoading()) {
  <!-- Skeleton Loading State -->
  <div class="tile hud-tile">
    <div class="metric-card">
      <div class="metric-header">
        <kendo-skeleton
          shape="text"
          animation="wave"
          width="120px"
          height="20px"
        ></kendo-skeleton>
      </div>
      <div class="metric-value">
        <kendo-skeleton
          shape="text"
          animation="wave"
          width="60px"
          height="32px"
        ></kendo-skeleton>
      </div>
      <div class="metric-comparison">
        <kendo-skeleton
          shape="text"
          animation="wave"
          width="150px"
          height="16px"
        ></kendo-skeleton>
      </div>
      <div class="metric-subtext">
        <kendo-skeleton
          shape="text"
          animation="wave"
          width="80px"
          height="14px"
        ></kendo-skeleton>
      </div>
    </div>
  </div>
} @else {
  <!-- Data Loaded State -->
  <div
    class="tile hud-tile"
    (click)="onContextMenuSelect({ text: 'View Data' })"
  >
    <div class="metric-card">
      <div class="metric-header">
        <h3>SLA Adherence</h3>
      </div>
      <!-- Use SlaAdherenceV2 data if available, otherwise fall back to the old inputs -->
      <div class="metric-value">
        {{
          slaAdherenceV2().sla_adherence_pct_current !== null ? slaAdherenceV2().sla_adherence_pct_current : 0
        }}%
      </div>
      <div
        class="metric-comparison"
        [class.up]="
          (slaAdherenceV2().sla_adherence_pct_current !== null
            ? slaAdherenceV2().sla_adherence_pct_current
            : 0) >
          (slaAdherenceV2().sla_adherence_pct_previous !== null
            ? slaAdherenceV2().sla_adherence_pct_previous
            : 0)
        "
        [class.down]="
          (slaAdherenceV2().sla_adherence_pct_current !== null
            ? slaAdherenceV2().sla_adherence_pct_current
            : 0) <
          (slaAdherenceV2().sla_adherence_pct_previous !== null
            ? slaAdherenceV2().sla_adherence_pct_previous
            : 0)
        "
      >
        @if (
          (slaAdherenceV2().sla_adherence_pct_current !== null
            ? slaAdherenceV2().sla_adherence_pct_current
            : 0) >
          (slaAdherenceV2().sla_adherence_pct_previous !== null
            ? slaAdherenceV2().sla_adherence_pct_previous
            : 0)
        ) {
          <span>↑</span>
        }
        @if (
          (slaAdherenceV2().sla_adherence_pct_current !== null
            ? slaAdherenceV2().sla_adherence_pct_current
            : 0) <
          (slaAdherenceV2().sla_adherence_pct_previous !== null
            ? slaAdherenceV2().sla_adherence_pct_previous
            : 0)
        ) {
          <span>↓</span>
        }
        {{
          ((slaAdherenceV2().sla_adherence_pct_current - slaAdherenceV2().sla_adherence_pct_previous) /
            (slaAdherenceV2().sla_adherence_pct_previous || 1)) *
            100 | number: '1.2-2'
        }}% vs Last Period
      </div>
      <div class="metric-subtext">
        Previous:
        {{
          slaAdherenceV2().sla_adherence_pct_previous !== null
            ? slaAdherenceV2().sla_adherence_pct_previous
            : 0
        }}%
      </div>
    </div>
  </div>
}

<kendo-dialog
  *ngIf="showPopup"
  (close)="close()"
  [width]="'95vw'"
  [height]="'90vh'"
  [minWidth]="'800px'"
  [maxWidth]="'1400px'"
>
  <kendo-dialog-titlebar>View Data</kendo-dialog-titlebar>
  <kendo-grid
    class="mxh-80v"
    [filterable]="true"
    [data]="gridService | async"
    [pageable]="{
      buttonCount: 5,
      info: true,
      type: 'numeric',
      pageSizes: [25, 50, 100, 200]
    }"
    [pageSize]="gridService.state.take"
    [skip]="gridService.state.skip"
    [(filter)]="gridService.state.filter"
    [loading]="gridService.loading"
    (dataStateChange)="gridService.onStateChange($event)"
    [sort]="this.gridService.state.sort"
    [sortable]="true"
    [resizable]="true"
  >
    <ng-template kendoGridToolbarTemplate>
      <button
        type="button"
        kendoGridExcelCommand
        class="cyflare-btn-secondary"
      >
        Export to Excel
      </button>
    </ng-template>
    <kendo-grid-column
      field="customer"
      title="Customer Name"
    ></kendo-grid-column>
    <kendo-grid-column
      field="parent_name"
      title="Parent Account Name"
    ></kendo-grid-column>
    <kendo-grid-column
      field="industry_name"
      title="Industry"
    ></kendo-grid-column>
    <kendo-grid-column
      field="alert_received_on"
      title="Received On"
      [width]="200"
    >
    <ng-template
      kendoGridFilterCellTemplate
      let-filter
      let-column="column"
    >
      <kendo-grid-date-filter-cell
        [column]="column"
        [filter]="filter"
        [operators]="dateFilterOperators"
      ></kendo-grid-date-filter-cell>
    </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="case_id"
      title="Case #"
    ></kendo-grid-column>
    <kendo-grid-column
      field="event_name"
      title="Event Name"
    ></kendo-grid-column>
    <kendo-grid-column
      field="case_severity"
      title="Severity"
    ></kendo-grid-column>
    <kendo-grid-column
      field="case_responded_on"
      title="First Response"
      [width]="200"
    >
    <ng-template
      kendoGridFilterCellTemplate
      let-filter
      let-column="column"
    >
      <kendo-grid-date-filter-cell
        [column]="column"
        [filter]="filter"
        [operators]="dateFilterOperators"
      ></kendo-grid-date-filter-cell>
    </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="sla_exceeded"
      title="SLA Exceeded"
    ></kendo-grid-column>
    <kendo-grid-column
      field="case_source"
      title="Source"
    ></kendo-grid-column>
    <kendo-grid-excel
      fileName="sla-data.xlsx"
      [fetchData]="allData"
    ></kendo-grid-excel>
  </kendo-grid>
</kendo-dialog>
